import React from "react";
import LinkedEntityCollapseList from "@common/components/linkedEntityCollapseList/LinkedEntityCollapseList.tsx";
import { useTranslation } from "@localization/useTranslation.ts";
import { useProcessAssetsField } from "./ProcessAssetsField.hooks.ts";

export interface ProcessAssetsFieldProps {
    assetIds: Array<string>;
    onChange: (assetIds: Array<string>) => void;
    disabled: boolean;
    isPreview: boolean;
    errorText?: string;
}

function ProcessAssetsField(props: ProcessAssetsFieldProps) {
    const { translateString } = useTranslation();
    const { isLoading, data, getLinkTo, getSuppliers, isSuppliersLoading } = useProcessAssetsField(props);

    return (
        <LinkedEntityCollapseList
            header={translateString("processAssetsHeader")}
            selectedIds={props.assetIds}
            selectableItems={data}
            onChange={props.onChange}
            getLinkTo={getLinkTo}
            details={{
                label: translateString("supplier"),
                toolTip: translateString("systemRelationSupplierToolTip"),
                getValues: getSuppliers,
                isLoading: isSuppliersLoading,
            }}
            addButtonText={translateString("addAsset")}
            removeItemText={translateString("removeAsset")}
            selectLabel={translateString("asset")}
            disabled={props.disabled}
            isLoading={isLoading}
            isPreview={props.isPreview}
            errorText={props.errorText}
        />
    );
}

export default ProcessAssetsField;
